import { render, staticRenderFns } from "./TopCartActivity.vue?vue&type=template&id=09b4f965"
import script from "./TopCartActivity.vue?vue&type=script&lang=ts"
export * from "./TopCartActivity.vue?vue&type=script&lang=ts"
import style0 from "./TopCartActivity.vue?vue&type=style&index=0&id=09b4f965&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports